import React from "react";
import { TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { tr, enUS, ru, ro, th } from "date-fns/locale";

const GenericDatePicker = ({ minDate = new Date(), minDateTime = new Date(), maxDate, minMsg = "", dateValue, size, onDateChange, readOnly, label, disabled, error, viewDays, id }) => {
    let language = enUS;
    if (localStorage.getItem("i18nextLng") === "tr-TR") {
        language = tr;
    } else if (localStorage.getItem("i18nextLng") === "ru-RU") {
        language = ru;
    } else if (localStorage.getItem("i18nextLng") === "ro-RO") {
        language = ro;
    } else if (localStorage.getItem("i18nextLng") === "th-TH") {
        language = th;
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={language}>
            <DateTimePicker
                disableToolbar
                variant="inline"
                views={viewDays ? ["year", "month", "day"] : ["year", "month", "day", "hours", "minutes"]} // takvim görünümü
                inputFormat={viewDays ? "dd.MM.yyyy" : "dd.MM.yyyy HH:mm"}
                renderInput={(props) => (
                    <TextField
                        id={id?.length > 0 ? id : null}
                        {...props}
                        error={error?.length > 0}
                        helperText={error ? error : null}
                        size={size}
                    />
                )}
                margin="normal"
                minDate={minDate}
                minDateTime={minDateTime}
                maxDate={maxDate ? maxDate : null}
                minDateMessage={minMsg}
                autoOk={true}
                value={dateValue}
                onChange={onDateChange}
                label={label}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                }}
                inputProps={readOnly ? { readOnly: true } : {}}
                InputProps={{ readOnly: true }}
                disabled={disabled}
                size="small"
            />
        </LocalizationProvider>
    );
};
export default GenericDatePicker;
